import PercentageValue from './PercentageValue';

export default PercentageValue;
